import React, { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
// import { PieChart, Settings, LogOut, Menu, X, Sun, Moon, Table2, ClipboardCheck, BarChart3, Users, Tags, UserCog } from 'lucide-react';
import { PieChart, Settings, LogOut, Menu, X, Sun, Moon } from 'lucide-react';
import { cn } from "../../../../lib/utils";
import { authStore } from "../../../../store/auth.store";
import { themeStore } from "../../../../store/theme.store";
import { reports, settings } from "../../../../config/router/authorizedRouter";
// import { reports, settings, timesheet, orgApprovals, orgReports, team, teamRoles, teamPeople } from "../../../../config/router/authorizedRouter";

const menuItems = [
  { path: reports, icon: PieChart, label: 'Reports' },
  // Lightweight company model: publish categories, watch what comes back
  // { path: team, icon: Users, label: 'Team' },
  // { path: teamRoles, icon: Tags, label: 'Roles' },
  // { path: teamPeople, icon: UserCog, label: 'People' },
  // // Heavier timesheet model — kept around for comparison
  // { path: timesheet, icon: Table2, label: 'Timesheet' },
  // { path: orgApprovals, icon: ClipboardCheck, label: 'Approvals' },
  // { path: orgReports, icon: BarChart3, label: 'Org reports' },
  { path: settings, icon: Settings, label: 'Settings' },
];

const SideMenu: React.FC = () => {
  const location = useLocation();
  const logOutCallback = authStore(state => state.logOut);
  const [collapsed, setCollapsed] = useState(true);

  const isDark = themeStore(state => state.isDark);
  const setDark = themeStore(state => state.setDark);

  return (
    <>
      {/* Mobile toggle button */}
      <button
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-sidebar text-sidebar-foreground"
        onClick={() => setCollapsed(!collapsed)}
      >
        {collapsed ? <Menu className="h-5 w-5" /> : <X className="h-5 w-5" />}
      </button>

      {/* Overlay for mobile */}
      {!collapsed && (
        <div
          className="lg:hidden fixed inset-0 bg-black/50 z-30"
          onClick={() => setCollapsed(true)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={cn(
          "fixed inset-y-0 left-0 z-40 w-[60px] bg-sidebar flex flex-col transition-transform duration-200",
          collapsed ? "-translate-x-full lg:translate-x-0" : "translate-x-0"
        )}
      >
        <nav className="flex-1 flex flex-col items-center py-4 gap-2">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setCollapsed(true)}
                className={cn(
                  "p-3 rounded-md transition-colors",
                  isActive
                    ? "bg-sidebar-accent text-sidebar-accent-foreground"
                    : "text-sidebar-foreground hover:bg-sidebar-accent/50"
                )}
                title={item.label}
              >
                <item.icon className="h-5 w-5" />
              </Link>
            );
          })}
        </nav>

        <div className="p-4 flex flex-col items-center gap-2">
          <button
            onClick={() => setDark(!isDark)}
            className="p-3 rounded-md text-sidebar-foreground hover:bg-sidebar-accent/50 transition-colors"
            title={isDark ? "Light mode" : "Dark mode"}
          >
            {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
          </button>
          <button
            onClick={logOutCallback}
            className="p-3 rounded-md text-sidebar-foreground hover:bg-sidebar-accent/50 transition-colors"
            title="Log out"
          >
            <LogOut className="h-5 w-5" />
          </button>
        </div>
      </aside>
    </>
  );
};

export default SideMenu;
